import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  loginWithGoogle: {
    method: 'GET',
    url: `${configs.baseUrl}/api/auth/google/callback/`,
  },
  loginWithSSO: {
    method: 'GET',
    url: `${configs.baseUrl}/api/auth/saml`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const loginWithGoogle = async (params) => {
  const res = await resource.loginWithGoogle(params)

  return res.body
}

const loginWithSSO = async (params) => {
  const res = await resource.loginWithSSO(params)

  return res.body
}

export default {
  initResource,
  loginWithGoogle,
  loginWithSSO,
}
